export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              今日实时更新 · 200+条新鲜爆料已上线
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              51吃瓜网入口
              <span className="block text-primary-500 mt-1">全网最热吃瓜爆料平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 max-w-xl lg:max-w-none mx-auto lg:mx-0 mb-5 font-medium">
              海量黑料每日追踪，一手爆料即时送达
            </p>

            <div className="max-w-xl lg:max-w-none mx-auto lg:mx-0 space-y-3 mb-7">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                51吃瓜网入口汇聚全网最新、最全的娱乐八卦与明星爆料，覆盖影视圈、综艺圈、网红圈等多领域黑料资讯。平台编辑团队7×24小时不间断追踪，第一时间为你送达独家内幕与深度解析。无论你是资深吃瓜群众还是偶尔围观的八卦爱好者，这里都有你想要的瓜——新鲜、热辣、有料。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                当前站内热门话题涵盖顶流塌房追踪、综艺内幕揭秘、网红翻车实况以及选秀造假盘点，每日更新超200条一手爆料，满足你对娱乐圈真相的所有好奇心。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">200+</div>
                <div className="text-xs md:text-sm text-foreground-500">每日更新条数</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden md:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">7×24h</div>
                <div className="text-xs md:text-sm text-foreground-500">全天候追踪</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden md:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">千万级</div>
                <div className="text-xs md:text-sm text-foreground-500">忠实吃瓜用户</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line mr-1.5"></i>
                查看今日热榜
              </a>
              <a
                href="#contact"
                onClick={(e) => handleNavClick(e, '#contact')}
                className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 rounded-full border-2 border-foreground-300 text-foreground-700 font-medium text-sm hover:border-primary-400 hover:text-primary-500 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line mr-1.5"></i>
                我要投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/40 to-accent-200/30 rounded-3xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20digital%20art%20composition%20with%20flowing%20warm%20crimson%20and%20amber%20gradient%20waves%20on%20deep%20dark%20background%2C%20geometric%20network%20patterns%20suggesting%20information%20flow%20and%20social%20media%20trends%2C%20modern%20minimalist%20tech%20aesthetic%2C%20soft%20glowing%20floating%20particles%2C%20editorial%20magazine%20quality%2C%20elegant%20atmospheric%20composition%20with%20deep%20shadows%20and%20warm%20highlights%2C%20no%20text%20no%20words%20no%20letters&width=960&height=720&seq=hero-visual-2026&orientation=landscape"
                  alt="51吃瓜网入口 - 全网最热吃瓜爆料平台视觉图"
                  title="51吃瓜网入口 - 全网最热吃瓜爆料平台"
                  className="w-full h-auto object-cover"
                  width="960"
                  height="720"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-background-50 rounded-xl px-4 py-2.5 shadow-md border border-background-200/70">
                <div className="flex items-center gap-2 text-xs text-foreground-600">
                  <span className="w-2 h-2 rounded-full bg-green-500"></span>
                  实时数据更新中
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}